export default __webpack_public_path__ + "static/media/CNo.58-1.19149d84.jpg";